import type { ElementType, ReactNode } from 'react'

import { useReveal } from '@/lib/motion'
import { cn } from '@/lib/cn'

/**
 * Reveal membungkus bagian halaman agar muncul ketika tergulir ke layar.
 *
 * Jeda bertingkat (delay) dipakai untuk memberi kesan berurutan pada
 * sekumpulan kartu; angkanya sengaja kecil supaya halaman tidak terasa
 * lambat bagi yang menggulir cepat.
 */
export function Reveal({
  children,
  delay = 0,
  as: Tag = 'div',
  className,
}: {
  children: ReactNode
  delay?: number
  as?: ElementType
  className?: string
}) {
  const ref = useReveal<HTMLDivElement>(delay)

  return (
    <Tag ref={ref} className={cn('reveal', className)}>
      {children}
    </Tag>
  )
}
